// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1MzUI","rowsWrapper":"styles_rowsWrapper__1iVgU"};